// extracted by mini-css-extract-plugin
export default {"Box":"action-buttons-module__Box--PcnYh"};